import { useEconomicCalendarSectionContent } from './useEconomicCalendarSectionContent';
import { parseEconomicCalendarEventImpactContent } from '../utils/economicCalendarContent';

export const useEconomicCalendarEventImpactContent = () =>
  useEconomicCalendarSectionContent(parseEconomicCalendarEventImpactContent);
